// Import all the icons
import analyticsIcon from "../../../assets/icons/analytics.svg";
import dashboardIcon from "../../../assets/icons/dashboard_icon.svg";
import effectivenessIcon from "../../../assets/icons/effectiveness_chefs_hat.svg";
import empowermentIcon from "../../../assets/icons/empowerment_mountain_footsteps.svg";
import exploreIcon from "../../../assets/icons/explore_icon.svg";
import logIcon from "../../../assets/icons/log.svg";
import peopleMatterIcon from "../../../assets/icons/people_matter_couple_heart.svg";
import usePflIcon from "../../../assets/icons/use_pfl_icon.svg";

export const MISSION_TAB_DATA = {
  mission: {
    text: "Leveraging the best science, Psych for Life® provides evidence-based, trustworthy, actionable, and cost-effective life skill solutions to help people effectively address everyday challenges of wellbeing, relationships, work, parenting, and community. In doing so, we support the growth and success of people from a wide range of communities and the organizations that care about them.",
    image: {
      src: "/apple-touch-icon.png",
      alt: "Psych for Life® Logo",
    },
  },
  values: {
    image: {
      src: usePflIcon,
      alt: "Psych for Life® Logo",
    },
    items: [
      {
        icon: peopleMatterIcon,
        title: "People matter",
        text: "People first; period.",
      },
      {
        icon: exploreIcon,
        title: "Science",
        text: "We follow the evidence.",
      },
      {
        icon: logIcon,
        title: "Trustworthiness",
        text: "It is the foundation for everything we do.",
      },
      {
        icon: effectivenessIcon,
        title: "Effectiveness",
        text: "The insights we provide will be actionable and impactful.",
      },
      {
        icon: empowermentIcon,
        title: "Empowerment",
        text: "How people feel as they confront challenges matters.",
      },
      {
        icon: dashboardIcon,
        title: "Inclusion and Accessibility",
        text: "Everyone with interest in cultivating personal growth, healthier relationships, and life success should have access to the insights provided by psychological science.",
      },
      {
        icon: analyticsIcon,
        title: "Transparency",
        text: "What we do and why we do it will be clearly articulated. What we don't do, and why we don't do it, will also be clearly articulated.",
      },
    ],
  },
};

export default MISSION_TAB_DATA;
